
import Vue from 'vue';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ClientsForm from '~/components/partials/public-portfolio/PublicPortfolioClients/ClientsForm.vue';
import BravadoCallout from '~/components/common/BravadoCallout/BravadoCallout.vue';

export default Vue.extend({
  name: 'PublicPortfolioAddClientsModal',
  components: {
    ClientsForm,
    PublicPortfolioModal,
    BravadoButtonV3,
    BravadoCallout,
  },
});
